// this component will be the standard layout used across pages
import React from "react";
import Head from "./head";
import Header from "./header";
import Footer from "./footer";

const Layout = ({ pageTitle, children, lang }) => {
  return (
    <>
      <Head pageTitle={pageTitle} lang={lang} />
      {/* {<!-- Google Tag Manager (noscript) -->} */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PM577QT"
          height="0"
          width="0"
          style={{
            display: "none",
            visibility: "hidden",
          }}
        ></iframe>
      </noscript>
      <Header lang={lang} />
      {/* children is a standard naming for everything you place inside the component, so we put it below as we want the content to be in the middle */}
      <div className="">{children}</div>
      <Footer lang={lang} />
    </>
  );
};

export default Layout;
